import axios from "axios";

export interface GiftMeta {
    token: string;
    plan: string;
    type: string;
    redeemed: boolean;
    key?: string;
}

export const getMine = () => axios.get<{ gifts: GiftMeta[] }>('/gifts/mine');
export const getGift = (token: string) => axios.get<GiftMeta>(`/gifts/${encodeURIComponent(token)}`);
export const redeemGift = (token: string) =>
    axios.post<{ ok: boolean; type: string; plan: string }>(`/gifts/${encodeURIComponent(token)}/redeem`);
